import httpRequest from "utils/httpRequest";
const URL = `/api`;

// Field === Site 같은 의미로 사용
// Frontend = Site
// Backend = Field 라고 부름

export const getSiteList = async (e_line, cur_page, group_id = null) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/fieldList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getSite = async (field_id) => {
  const requestBody = {
    field_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/field`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertSite = async (data, address) => {
  const requestBody = {
    corp_nm: "",
    group_id: data.group_id ?? "",
    field_nm: data.field_nm ?? "",
    ceo_nm: "",
    field_manager_id: data.field_manager_id ?? "",
    reg_no: "",
    reg_file_id: "",
    // data.address === 주소 상세주소
   // address: address + (data.instl_lc != null ? " " + data.instl_lc : ""),
    address: (address ?? "") + (data.address != null ? " " + data.address : ""),
    name: "",
    rank: "",
    dept: "",
    office_phone: data.office_phone ?? "",
    mobile_no: "",
    users: data.users ?? "",
    users_nm: data.users_nm ?? "",
    etc: data.etc ?? "",
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/insertFieldInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateSite = async (data, postResult) => {
  const requestBody = {
    corp_nm: "",
    group_id: data.group_id ?? "",
    field_id: data.field_id ?? "",
    field_nm: data.field_nm ?? "",
    ceo_nm: "",
    field_manager_id: data.field_manager_id ?? "",
    reg_no: "",
    reg_file_id: "",
    address: postResult ? postResult : data.address,
    name: "",
    rank: "",
    dept: "",
    office_phone:data.office_phone ?? "",
    mobile_no: "",
    users: data.users ?? "",
    users_nm: data.users_nm ?? "",
    etc: data.etc ?? "",
  };

  try {
    const response = await httpRequest(
      "post",
      `${URL}/updateFieldInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const copySite = async (field_id, field_nm) => {
  const requestBody = {
    field_id,
    field_nm,
  };

  try {
    const response = await httpRequest("post", `${URL}/copyField`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};
/**
 *
 * User Info Delete API
 */
export const deleteSite = async (field_id) => {
  const requestBody = {
    field_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/deleteFieldInfo`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getUserPopup = async () => {
  try {
    const response = await httpRequest("post", `${URL}/getCombo`);
    return response;
  } catch (error) {
    console.log(error);
  }
};
